// @tennis-matches/services/governance
// Tenant scope discovery for UI dropdowns (read-only).

import { getSupabaseClient } from "../supabase/index.js";

const SCHEMA = "app_config";

function __asStr(v) {
  return String(v ?? "").trim();
}

function __db(supabase) {
  return supabase && typeof supabase.schema === "function" ? supabase.schema(SCHEMA) : supabase;
}

function __supabaseErrorInfo(error) {
  if (!error) return null;
  return {
    message: __asStr(error?.message),
    code: __asStr(error?.code),
    details: __asStr(error?.details),
    hint: __asStr(error?.hint),
    status: Number(error?.status || 0) || null,
  };
}

function __rpcReason(error) {
  const code = __asStr(error?.code);
  const msg = __asStr(error?.message);
  if (!msg) return "rpc-error";
  if (code === "PGRST202" || code === "42883") return "rpc-missing";
  if (code === "PGRST106" || msg.toLowerCase().includes("invalid schema")) return "schema-unavailable";
  if (code === "42501") return "permission-denied";
  if (msg.includes("not-authenticated")) return "not-authenticated";
  return "rpc-error";
}

function __resolveSupabaseTarget() {
  if (typeof globalThis !== "undefined") {
    const ttb = String(globalThis.__TTB_ENV__?.TM_SUPABASE_TARGET || "").toLowerCase();
    if (ttb) return ttb;
  }
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return String(
      import.meta.env.VITE_TM_SUPABASE_TARGET || import.meta.env.TM_SUPABASE_TARGET || ""
    ).toLowerCase();
  }
  return "";
}

function __shouldPreferPublicAppConfigRpc() {
  const target = __resolveSupabaseTarget();
  return target === "test" || target === "staging" || target === "preview";
}

async function __rpcListVisibleTenantScopeIds(supabase) {
  if (__shouldPreferPublicAppConfigRpc()) {
    return supabase.rpc("list_visible_tenant_scope_ids");
  }
  const db = __db(supabase);
  const primary = await db.rpc("list_visible_tenant_scope_ids");
  if (!primary.error || __rpcReason(primary.error) !== "schema-unavailable") {
    return primary;
  }
  return supabase.rpc("list_visible_tenant_scope_ids");
}

export async function loadVisibleTenantScopeIdsRemote() {
  const supabase = await getSupabaseClient();
  if (!supabase) return { ok: false, reason: "no-supabase" };
  const { data, error } = await __rpcListVisibleTenantScopeIds(supabase);
  if (error) return { ok: false, reason: __rpcReason(error), error, errorInfo: __supabaseErrorInfo(error) };

  const scopeIds = Array.isArray(data) ? data.map((r) => __asStr(r?.scope_id || r)).filter(Boolean) : [];
  return { ok: true, scopeIds };
}

